import React from 'react'

const Fullstack_Dotnet = () => {
  return (
    <div>
        {/* collapseTwelve */}
        <div className="accordion-item mb-2">
        <h2 className="accordion-header" id="headingTwelve">
            <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwelve"aria-expanded="false" aria-controls="collapseTwelve">C#<span className="toggle-icon ms-auto"></span></button>
        </h2>
        <div id="collapseTwelve" className="accordion-collapse collapse" aria-labelledby="headingTwelve" data-bs-parent="#accordionCourses">
            <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
            <ul>
                <li>.NET Framework - CLR, FCL</li>
                <li>C++ v/s C#, Java v/s C#, C# History, C# Features, Example, Variables, Data Types, Operators, Keywords</li>
                <li>Control Statement</li>
                <li>if - else, Switch, For Loop, While Loop, Do - While Loop, Break, Continue, Goto, Comments</li>
                <li>Functions, Call By Value, Call By Reference, Out Parameter</li>
                <li>C# Arrays</li>
                <li>Multidimensional Array, Jagged Arrays, Params, Array Class, Command Line Args</li>
                <li>Object and Class, Constructor, Destructor, This, Static, Static Class, Static Constructor, Structs, Enum</li>
                <li>Properties</li>
                <li>Inheritance, Aggregation, Polymorphism</li>
                <li>Method Overloading, Method Overriding, Base, Polymorphism, Sealed</li>
                <li>Abstract, Interface, Namespaces, Access Modifiers, Encapsulation, Strings</li>
                <li>Exception Handling, try/catch, finally, Custom Exception, checked, unchecked, SystemException</li>
                <li>File IO, FileStream, StreamWriter, StreamReader, TextWriter, TextReader, BinaryWriter, BinaryReader, StringWriter, StringReader, FileInfo, DirectoryInfo, Serialization, Deserialization, System.IO</li>
                <li>List&lt;T&gt;, HashSet&lt;T&gt;, SortedSet&lt;T&gt;, Stack&lt;T&gt;, Queue&lt;T&gt;, LinkedList&lt;T&gt;, Dictionary&lt;K,V&gt;, SortedDictionary&lt;K,V&gt;, SortedList&lt;K,V&gt;</li>
                <li>Generics</li>
                <li>Delegates</li>
                <li>Reflection</li>
                <li>Anonymous Function</li>
                <li>Multithreading, Thread Life Cycle, Thread class, Main Thread, Thread Example, Thread Sleep, Thread Abort, Thread Join, Thread Name, ThreadPriority</li>
                <li>Mini Project & Internal Theory& Practical Exam</li>
            </ul>
            </div>
        </div>
        </div>

        {/* collapseThirteen */}
        <div className="accordion-item mb-2">
        <h2 className="accordion-header" id="headingThirteen">
            <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirteen" aria-expanded="false" aria-controls="collapseThirteen">
            ASP .NET
            <span className="toggle-icon ms-auto"></span>
            </button>
        </h2>
        <div id="collapseThirteen" className="accordion-collapse collapse" aria-labelledby="headingThirteen" data-bs-parent="#accordionCourses">
            <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
            <ul>
                <li>ASP .NET WF Introduction, ASP .NET WF Features, ASP .NET WF Project, ASP .NET WF Example, ASP .NET Server Controls, ASP .NET Label, ASP .NET TextBox, ASP .NET Button, ASP .NET Hyperlink, ASP .NET RadioButton, ASP .NET Calendar, ASP .NET CheckBox, ASP .NET LinkButton, ASP .NET FileUpload, Multiple FileUpload, ASP .NET Download File, ASP .NET Cookie, ASP .NET Session, ASP .NET DropDownList, ASP .NET DataList, ASP .NET DataGrid, WF User Registration, WF Events Handling, WF Authentication, WF Model Binding, HTML Server Controls</li>
                <li>ASP .NET Validations</li>
                <li>CompareValidator, RangeValidator, RegularExpression, ValidatorRequired, FieldValidator, Validation Summary</li>
                <li>Master Pages, Applying themes, CSS</li>
                <li>MVC</li>
                <li>ASP .NET MVC, MVC Project, MVC Controller, MVC Actions, MVC Actions Selectors, MVC Action Filters, MVC Model, MVC Model Binding, MVC View, MVC Validation, MVC EntityFramework, MVC Authentication, MVC Bootstrap, MVC Routing, MVC Scaffolding, MVC ViewBag</li>
                <li>WPF & WCF</li>
                <li>LINQ OVERVIEW, Types of LINQ, Basic concepts, lambda expression, Standard query operators, Sample queries</li>
                <li>Web API overview, Web API routing, Action return types, Media Type Formatters, Filters, Parameter binding</li>
                <li>Web API project, CRUD OPERATION</li>
                <li>Assignment / Practical task / Programs</li>
                <li>Major Project & Internal Theory & Practical Exam</li>
            </ul>
            </div>
        </div>
        </div>

        {/* collapseFourteen */}
        <div className="accordion-item mb-2">
        <h2 className="accordion-header" id="headingFourteen">
            <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFourteen" aria-expanded="false" aria-controls="collapseFourteen">
            ASP Core
            <span className="toggle-icon ms-auto"></span>
            </button>
        </h2>
        <div id="collapseFourteen" className="accordion-collapse collapse" aria-labelledby="headingFourteen" data-bs-parent="#accordionCourses">
            <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
            <strong>1) Introduction What is ASP.NET Core?</strong> 
            <ul>
                <li>ASP.NET Core Features</li>
                <li>Advantages of ASP.NET Core</li>
                <li>MVC Pattern Understanding ASP.NET Core MVC</li>
                <li>ASP.NET Core vs. ASP.NET MVC vs. ASP.NET Web Forms</li>
            </ul>

            <strong>2) ASP.NET Core Environment Setup</strong>
            <ul>
                <li>ASP .NET Core First Application</li>
                <li>Project Layout</li>
                <li>Understanding Life Cycle of ASP.Net Core Request</li>
            </ul>

            <strong>3) Controllers & Action</strong>
            <ul>
                <li>Controllers Overview Action Methods and IActionResult object</li>
                <li>Passing data from Controller to View</li>
                <li>Understanding Action Selectors</li>
                <li>Action Filters Building Custom Action Filters Middleware</li>
                <li>Asynchronous Action Methods</li>
            </ul>

            <strong>4) Views This deals</strong>
            <ul>
                <li>what is a view</li>
                <li>razor syntax and different types of views with examples.</li>
                <li>Introducing Razor View</li>
                <li>Advantages of Razor View Razor Syntax</li>
                <li>Types of Views Partial Views</li>
                <li>Layout Pages Special Views View Categorization based on Model</li>
            </ul>

            <strong>5) Html Helpers</strong>
            <ul>
                <li>Built-In Html Helpers</li>
                <li>URL helpers Tag Helpers</li>
                <li>Custom Tag Helpers</li>
            </ul>

            <strong>6) Model Binding</strong>
            <ul>
                <li>Html Form behavior</li>
                <li>Model Binder Overview</li>
                <li>DefaultModelBinder</li>
                <li>Binding to Complex Classes</li>
                <li>IFormCollection Model Binding</li>
                <li>IFormFile Model Binder</li>
                <li>Bind Attribute</li>
                <li>TryUpdateModelAsync</li>
            </ul>

            <strong>7) Validations & Data</strong>
            <ul>
                <li>Data Annotations and Validations Overview</li>
                <li>Validations with Data Annotation</li>
                <li>Server Side and Client Side Validation</li>
                <li>Custom Server side validation</li>
            </ul>

            <strong>8) State management Techniques</strong>
            <ul>
                <li>Cookies</li>
                <li>Sessions</li>
            </ul>

            <strong>9) Security.</strong>
            <ul>
                <li>Authentication and Authorization</li>
                <li>Implementing Security using ASP.NET Core Identity</li>
            </ul>

            <strong>10) MVC and Entity Framework Core</strong>
            <ul>
                <li>Basic CRUD Operations using Entity Framework</li>
                <li>Separation of work using BO Classes</li>
                <li>Writing Generic Class / Repository Caching in Repository</li>
            </ul>
            </div>
        </div>
        </div>

        {/* collapseFifteenth */}
        <div className="accordion-item mb-2">
        <h2 className="accordion-header" id="headingFifteenth">
            <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFifteenth" aria-expanded="false" aria-controls="collapseFifteenth">
            AZURE
            <span className="toggle-icon ms-auto"></span>
            </button>
        </h2>
        <div id="collapseFifteenth" className="accordion-collapse collapse" aria-labelledby="headingFifteenth" data-bs-parent="#accordionCourses">
            <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
            <strong>1) Introduction to Azure</strong>
            <ul>
                <li>Azure regions, Regions pairs</li>
                <li>Azure sovereign regions</li>
                <li>Azure availability zone</li>
                <li>Azure Data centre</li>
                <li>Azure Resources and resource groups</li>
                <li>Subscriptions</li>
                <li>Management group</li>
            </ul>

            <strong>2) Networking</strong>
            <ul>
                <li>OSI Model Protocols</li>
                <li>TCP</li>
                <li>IP</li>
                <li>Ports</li>
                <li>HTTP/HTTPS</li>
                <li>DNS</li>
                <li>Router, Switches, Firewall, Curl command</li>
            </ul>

            <strong>3) Azure computing</strong>
            <ul>
                <li>Virtual Machine</li>
                <li>Services | - Server,Storage,Database</li>
                <li>Create a virtual Machine</li>
                <li>Process to Create vm | Security Group | Firewall | Port-80</li>
                <li>WinScp - Hosting</li>
                <li>Web Hosting</li>
            </ul>

            </div>
        </div>
        </div>
    </div>
  )
}

export default Fullstack_Dotnet